import { Reveal } from "@/components/Reveal";
import NewsletterForm from "@/components/NewsletterForm";

const Letters = () => (
  <section data-testid="letters-section" className="border-t border-stone/60 bg-cream/70">
    <div className="mx-auto max-w-3xl px-6 md:px-10 py-28 md:py-36 text-center">
      <Reveal>
        <p className="eyebrow mb-6">Tara’s Letters</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight" data-testid="letters-headline">
          A quieter kind of email.
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-7 text-base md:text-lg leading-relaxed text-taupe max-w-xl mx-auto">
          Reflections, practices and gentle reminders to help you understand
          your nervous system and come back to yourself.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-10 flex justify-center">
          <NewsletterForm source="letters" testid="letters" />
        </div>
        <p className="mt-6 text-xs text-taupe/70 tracking-wide">
          No noise. No urgency. Unsubscribe anytime.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Letters;
